import styled, { css } from 'styled-components'

export const DetailsCard = styled.div<{ $variant?: 'default' | 'compact' }>(
  ({ theme, $variant }) => css`
    align-items: flex-start;
    display: flex;
    gap: ${theme.space['8']};
    width: 100%;

    ${
      $variant === 'compact'
        ? css`
          border: none;
          border-radius: 0;
          padding: 0;
        `
        : css`
          border: ${theme.border.size['1']} solid ${theme.colors.gray400};
          border-radius: ${theme.border.radius['4']};
          padding: ${theme.space['12']};
        `
    }
  `,
)

export const DetailsContent = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space[4],
}))

export const DetailsTitle = styled.div(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.4rem',
  fontWeight: 500,
  lineHeight: '2.4rem',
}))

export const DetailsValueRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))

export const DetailsValue = styled.div(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.4rem',
  fontWeight: 600,
}))
